export const appSQ = {
  'activities': {
    'cycling': 'Çiklizëm',
    'hiking': 'Ecje në natyrë',
    'running': 'Vrapim',
    'skitouring': 'Skitour',
    'walking': 'Shëtitje',
    'asphalt': 'Asfalt',
    'bitumenduro': 'Bitumenduro',
    'onoff': 'On/Off',
    'real-dirt': 'Dhe i vërtetë',
    'bar': 'Bar'
  },
  'sidemenu': {
    'project': 'Projekti',
    'offline': 'Jashtë linje',
    'settings': 'Cilësimet',
    'credits': 'Kredite',
    'disclaimer': 'Mohim'
  },
  'components': {
    'cardtrack': {
      'delete': 'Fshi',
      'remove': 'Hiq'
    },
    'map': {
      'btnrec': {
        'slide': 'Rrëshqit për të regjistruar'
      },
      'register': {
        'cancel': 'Anulo',
        'photo': 'Foto',
        'title': 'Regjistro',
        'track': 'Gjurmë',
        'vocal': 'Shënim zanor',
        'waypoint': 'Pikë e rrugës'
      }
    },
    'searchbar': {
      'filters': 'Filtro sipas',
      'nofilters': 'Asnjë filtër nuk përputhet me kërkimin e kryer',
      'noplaces': 'Asnjë vend nuk përputhet me kërkimin e kryer',
      'notracks': 'Asnjë gjurmë nuk përputhet me kërkimin e kryer',
      'placeholder': 'kërko',
      'places': 'Vende',
      'tracks': 'Gjurmë'
    },
    'slopechart': {
      'slope': {
        'label': 'pjerrësi'
      },
      'surfaces': {
        'asphalt': {
          'label': 'asfalt'
        },
        'concrete': {
          'label': 'beton'
        },
        'dirt': {
          'label': 'dhe'
        },
        'grass': {
          'label': 'bar'
        },
        'gravel': {
          'label': 'zhavorr'
        },
        'paved': {
          'label': 'i shtruar'
        },
        'sand': {
          'label': 'rërë'
        }
      }
    }
  },
  'generic': {
    'cancel': 'anulo',
    'confirm': 'konfirmo',
    'delete': 'fshi',
    'error': 'Ndodhi një gabim. Provo përsëri më vonë',
    'hour': 'orë',
    'minute': 'min',
    'ok': 'ok',
    'retry': 'provo përsëri',
    'warning': 'Kujdes'
  },
  'modals': {
    'coin': {
      'buttonall': 'Shiko të gjitha paketat e monedhave',
      'buttonone': 'Bli 1 Monedhë / 1€',
      'defaultmessage': 'Bli monedha për të shkarkuar përmbajtje jashtë linje',
      'info1': 'Mund të blesh një gjurmë të vetme',
      'info2': 'Ke gjithçka në dispozicion edhe pa mbulim',
      'info3': 'Merr njoftime të afërsisë',
      'subinfo1': 'Bli një monedhë të vetme për 1€',
      'subinfo2': 'Navigim i saktë edhe kur je jashtë linje',
      'subinfo3': 'Të njoftojmë në afërsi të pikave të interesit në rrugë'
    },
    'giftcoin': {
      'button': 'Fillo të eksplorosh',
      'info': 'Ke menjëherë dhuratë 2 monedha webmapp për të shkarkuar përmbajtje jashtë linje!',
      'title': 'Mirë se vjen në webmapp!'
    },
    'login': {
      'email': 'E-mail',
      'errors': {
        '401': 'Kredencialet që ke futur nuk janë të sakta. Kontrollo e-mail dhe fjalëkalimin dhe provo përsëri',
        'form': {
          'emailInvalid': 'Ke futur një e-mail të pavlefshëm',
          'emailRequired': 'E-mail është i detyrueshëm',
          'passwordRequired': 'Fjalëkalimi është i detyrueshëm'
        },
        'generic': 'Oops! Diçka shkoi keq! Prit disa minuta dhe provo përsëri.'
      },
      'forgotPassword': 'Ke harruar fjalëkalimin?',
      'login': 'Hyr',
      'message': 'Hyr me kredencialet e tua për të vazhduar.',
      'password': 'Fjalëkalim',
      'rememberLogin': 'Mbaj mend kredencialet',
      'title': 'Hyr',
      'welcome': 'Mirë se u ktheve!'
    },
    'photo': {
      'next': 'Tjetër',
      'popover': {
        'cancel': 'Anulo',
        'library': 'Nga biblioteka',
        'shot': 'Bëj një foto',
        'title': 'Burimi i imazhit'
      },
      'save': {
        'addphoto': 'Shto foto',
        'formphototitle': 'Titulli ',
        'formtitle': 'Jepi një titull fotove të tua',
        'modalconfirm': {
          'cancel': 'Anulo',
          'confirm': 'Po, fshi',
          'text': 'Nëse e fshin nuk do të shtohet në këtë regjistrim',
          'title': 'Je i sigurt që dëshiron të fshish këtë foto nga regjistrimi?'
        },
        'placeholder': 'Këtu mund të futësh një titull',
        'savebtn': 'Ruaj',
        'title': 'Regjistro foto'
      },
      'single': {
        'formphototitle': 'Titulli',
        'placeholder': 'Këtu mund të futësh një titull',
        'savebtn': 'Bërë',
        'title': 'Modifiko foto'
      }
    },
    'settings': {
      'alert': {
        'logout': "Je i sigurt që dëshiron të ç'kyçësh llogarinë tënde?"
      },
      'logout': "Ç'kyçu",
      'title': 'Cilësimet',
      'version': 'Versioni'
    },
    'storesuccess': {
      'back': 'Kthehu te kërkimi',
      'buttondownload': 'Shkarko tani',
      'continue': 'Dëshiron të përdorësh menjëherë monedhën tënde për të shkarkuar ',
      'continue2': '?',
      'info': 'Mund të kontrollosh bilancin e monedhave të tua direkt në zonën tënde personale!',
      'or': 'Ose',
      'title': 'Faleminderit që ke blerë monedhën tënde të parë!'
    },
    'success': {
      'photos': {
        'text': "Fotot e tua janë ruajtur me sukses. Mund t'i shikosh duke hyrë në profilin tënd.",
        'title': 'Fotot u regjistruan me sukses!'
      },
      'return': 'Kthehu për të eksploruar',
      'track': {
        'avgspeed': 'Shpejtësia mesatare',
        'odo': 'Km të përshkuara',
        'slope': 'Diferenca e lartësisë',
        'text': "Gjurmët janë ruajtur me sukses. Mund t'i shikosh duke hyrë në profilin tënd.",
        'time': 'Koha',
        'title': 'Aktiviteti u regjistrua me sukses!',
        'topspeed': 'Shpejtësia maksimale'
      },
      'waypoint': {
        'text': 'Ke ruajtur me sukses pikën tënde të rrugës. Mund ta shikosh duke hyrë në profilin tënd.',
        'title': 'Pika e rrugës u regjistrua me sukses!'
      }
    }
  },
  'pages': {
    'downloadlist': {
      'cancel': 'Anulo',
      'deleteselected': 'Fshi të zgjedhurat',
      'nodata': 'Nuk ke shkarkuar ende asnjë gjurmë',
      'nodata2': 'Me përmbajtjet për përdorim jashtë linje navigon me qetësi edhe pa lidhje!',
      'nodatabtn': 'Eksploro',
      'select': 'Zgjidh',
      'title': 'Shkarkime'
    },
    'favourites': {
      'nodata': 'Nuk ka gjurmë të preferuara, kliko mbi ikonën e zemrës së një gjurme për ta shtuar në këtë listë',
      'title': 'Të preferuarat'
    },
    'home': {
      'button': 'Zgjidh një pikë nisjeje',
      'closerTracks': 'Gjurmë afër',
      'intro': 'Planifikojmë së bashku aventurën tënde të ardhshme',
      'mostViewedTracks': 'Gjurmët më të shikuara',
      'nocloserTracks': 'Duket se nuk ka gjurmë afër vendndodhjes aktuale',
      'welcome': 'Mirë se vjen!'
    },
    'itinerary': {
      'btnFullMapExpand': 'Zgjero',
      'btnFullMapReduce': 'Redukto',
      'btndnavigate': 'Navigo',
      'btndownload': 'Shkarko',
      'btnfavourite': 'Të preferuarat',
      'btnshare': 'Ndaj',
      'description': {
        'description': 'Përshkrimi',
        'gallery': 'Galeria'
      },
      'detail': {
        'ascent': 'Diferenca e lartësisë +',
        'descent': 'Diferenca e lartësisë -',
        'distance': 'Gjatësia',
        'ele_from': 'Lartësia e nisjes',
        'ele_max': 'Lartësia maksimale',
        'ele_min': 'Lartësia minimale',
        'ele_to': 'Lartësia e mbërritjes'
      },
      'directions': 'Merr udhëzime',
      'download': 'Shkarko',
      'downloadpanel': {
        'complete': 'Shkarkimi përfundoi',
        'dontclose': 'Mos e mbyll aplikacionin gjatë fazës së instalimit të të dhënave',
        'downdata': 'Shkarkimi i të dhënave',
        'downsize': 'Madhësia e shkarkimit',
        'download': 'Shkarko',
        'downloadbtn': 'Shkarko',
        'downloading': 'Duke shkarkuar',
        'downmap': 'Shkarkimi i hartës',
        'downmedia': 'Shkarkimi i mediave',
        'downsetup': 'Konfigurimi fillestar',
        'gotobtn': 'Shko te shkarkimet e mia',
        'install': 'Instalimi'
      },
      'favbtn': {
        'isFavourite': 'Shtuar te të preferuarat!',
        'isNotFavourite': 'Hequr nga të preferuarat!'
      },
      'modalconfirm': {
        'cancel': 'Anulo',
        'confirm': 'Dil',
        'text': 'Dil pa përfunduar shkarkimin e gjurmës?',
        'title': 'Ndërprerë shkarkimin?'
      },
      'modalNotImpemented': {
        'text': 'Së shpejti',
        'title': 'Aktualisht jo i disponueshëm',
        'confirm': 'ok'
      },
      'navigate': 'Navigo',
      'share': 'Ndaj',
      'tabdescription': 'Përshkrimi',
      'tabdetail': 'Detajet',
      'tabeat': 'Ku të hash',
      'tabhowto': 'Si të arrish',
      'tabviability': 'Përshkueshmëria',
      'tabwalkable': 'Aksesueshmëria',
      'viability': {
        'info': 'Informacione të tjera',
        'title': 'Praktikueshmëria e rrugës'
      }
    },
    'map': {
      'loading': 'duke kërkuar...',
      'recordingbtn': 'Reg. në proces',
      'searchherebtn': 'Kërko në këtë zonë'
    },
    'photodetail': {
      'delete': 'Fshi regjistrimin',
      'edit': 'Modifiko regjistrimin',
      'title': 'Foto e regjistruar'
    },
    'photolist': {
      'noitem': 'Aktualisht nuk ka foto të regjistruara',
      'title': 'Foto të regjistruara'
    },
    'profile': {
      'data': {
        'data': 'Përdorimi i të dhënave',
        'downloads': 'Shkarkime',
        'tracks': 'Gjurmë të shkarkuara'
      },
      'loggedOut': {
        'login': 'Hyr',
        'signup': 'Regjistrohu',
        'slides': {
          '0': 'Hyr dhe shkarko gjurmët e tua të preferuara',
          '1': "Mund t'i ndash edhe me shokët e udhëtimit"
        }
      },
      'records': {
        'photos': 'Foto',
        'title': 'Regjistrime',
        'tracks': 'Gjurmë',
        'vocals': 'Shënime zanore',
        'waypoints': 'Pika të rrugës'
      },
      'title': 'Profili',
      'lang': 'gjuha',
      'langPlaceholder': 'zgjidh',
      'projectlink': 'Projekti',
      'disclaimerlink': 'Mohim',
      'creditslink': 'Kredite',
      'privacylink': 'Privatësia'
    },
    'register': {
      'averagespeed': 'Shpejtësia mesatare',
      'backgroundbtn': 'Regjistro në sfond',
      'currentspeed': 'Shpejtësia aktuale',
      'modalconfirm': {
        'cancel': 'Anulo',
        'confirm': 'Konfirmo',
        'text': 'Pasi të konfirmohet nuk do të mund të rifillosh këtë navigim',
        'title': 'Konfirmon që dëshiron të përfundosh regjistrimin?'
      },
      'modalexit': {
        'cancel': 'Anulo',
        'confirm': 'Fshi',
        'text': 'Duke përfunduar veprimin gjurma do të fshihet nga profili yt dhe nga Webmapp. Operacioni nuk mund të anulohet.',
        'title': 'Fshi përgjithmonë?'
      },
      'modalphotos': {
        'deselectall': "Ç'zgjidh të gjitha",
        'noimages': 'Nuk ka imazhe të shkrepura gjatë regjistrimit të rrugës',
        'savebtn': 'Ngarko',
        'selectall': 'Zgjidh të gjitha',
        'title': 'Ngarko foto'
      },
      'modalsave': {
        'closemodal': {
          'back': 'Kthehu te regjistrimi',
          'cancel': 'Anulo',
          'delete': 'Fshi regjistrimin'
        },
        'deletebtn': 'DIL PA RUAR',
        'formactivity': 'Lloji i aktivitetit',
        'formactivityerror': 'Lloji i aktivitetit është një fushë e detyrueshme',
        'formactivityplaceholder': 'Zgjidh',
        'formdescription': 'Përshkrimi',
        'formdescriptionplaceholder': 'Nëse dëshiron mund të shtosh një përshkrim',
        'formphotos': 'Shto foto të shkrepura gjatë rrugës',
        'formtitle': 'Titulli i gjurmës',
        'formtitleerror': 'Fusha e titullit është e detyrueshme',
        'formtitleplaceholder': 'Fut një titull',
        'phototextshort': 'Foto',
        'savebtn': 'Ruaj',
        'title': 'Ruaj gjurmën',
        'titleEdit': 'Modifiko gjurmën'
      },
      'odo': 'Km të përshkuara',
      'pausebtn': 'Pauzë',
      'resumebtn': 'Vazhdo',
      'stopbtn': 'Përfundo',
      'title': 'Regjistro një gjurmë'
    },
    'registeruser': {
      'cf': 'Kodi Fiskal',
      'cfextra': 'Pse të kërkojmë CF?',
      'cfph': 'XXXXXXXXXXXXXXXX',
      'cfpopovermessage': 'Nëse je Anëtar/Anëtare CAI fut CF-në tënde gjatë regjistrimit. Për ty shkarkimi i etapave të Sentiero Italia CAI do të jetë automatikisht falas!',
      'cfpopovertitle': 'Pse të kërkojmë Kodin Fiskal?',
      'confirmPassword': 'Konfirmo fjalëkalimin',
      'confirmPasswordph': 'Përsërit fjalëkalimin',
      'email': 'Email',
      'emailph': 'shembull@email.com',
      'errors': {
        'form': {
          'nameRequired': 'Është e nevojshme të futet një emër'
        },
        'form.cfInvalid': 'Kodi fiskal nuk është i vlefshëm',
        'form.confirmPasswordInvalid': 'Konfirmimi nuk përputhet me fjalëkalimin e futur më sipër',
        'form.confirmPasswordRequired': 'Është e nevojshme të konfirmohet fjalëkalimi',
        'form.emailInvalid': 'Email nuk është i vlefshëm',
        'form.emailRequired': 'Është e nevojshme të futet një email',
        'form.passwordRequired': 'Është e nevojshme të futet një fjalëkalim'
      },
      'genericError': 'Gabim gjatë regjistrimit të përdoruesit',
      'loading': 'Regjistrimi në proces',
      'name': 'Emri',
      'nameph': 'fut emrin tënd',
      'password': 'Fjalëkalim',
      'passwordph': 'fut fjalëkalimin',
      'privacy1': "Duke klikuar \"Regjistrohu\" pranon tonë ",
      'privacy2': 'dhe',
      'privacy3': '',
      'privacylink1': 'Politika e Privatësisë',
      'privacylink2': 'Kushtet dhe termat',
      'registerbutton': 'Regjistrohu',
      'title': 'Bashkohu me komunitetin e webmapp!'
    },
    'route': {
      'btnFullMapExpand': 'Zgjero',
      'btnFullMapReduce': 'Redukto',
      'btndnavigate': 'Navigo',
      'btndownload': 'Shkarko',
      'btnfavourite': 'Të preferuarat',
      'btnshare': 'Ndaj',
      'description': {
        'description': 'Përshkrimi',
        'gallery': 'Galeria'
      },
      'detail': {
        'from': 'Nisja',
        'to': 'Mbërritja',
        'ascent': 'Diferenca e lartësisë +',
        'descent': 'Diferenca e lartësisë -',
        'distance': 'Gjatësia',
        'duration_forward': 'kohëzgjatja e shkuarjes',
        'duration_backward': 'kohëzgjatja e kthimit',
        'difficulty': 'Vështirësia',
        'ele_from': 'Lartësia e nisjes',
        'ele_max': 'Lartësia maksimale',
        'ele_min': 'Lartësia minimale',
        'ele_to': 'Lartësia e mbërritjes'
      },
      'directions': 'Merr udhëzime',
      'download': 'Shkarko',
      'downloadpanel': {
        'complete': 'Shkarkimi përfundoi',
        'dontclose': 'Mos e mbyll aplikacionin gjatë fazës së instalimit të të dhënave',
        'downdata': 'Shkarkimi i të dhënave',
        'downsize': 'Madhësia e shkarkimit',
        'download': 'Shkarko',
        'downloadbtn': 'Shkarko',
        'downloading': 'Duke shkarkuar',
        'downmap': 'Shkarkimi i hartës',
        'downmedia': 'Shkarkimi i mediave',
        'downsetup': 'Konfigurimi fillestar',
        'gotobtn': 'Shko te shkarkimet e mia',
        'install': 'Instalimi'
      },
      'favbtn': {
        'isFavourite': 'Shtuar te të preferuarat!',
        'isNotFavourite': 'Hequr nga të preferuarat!'
      },
      'modalconfirm': {
        'cancel': 'Anulo',
        'confirm': 'Dil',
        'text': 'Dil pa përfunduar shkarkimin e gjurmës?',
        'title': 'Ndërprerë shkarkimin?'
      },
      'navigate': 'Navigo',
      'share': 'Ndaj',
      'tabdescription': 'Përshkrimi',
      'tabdetail': 'Detajet',
      'tabeat': 'Ku të hash',
      'tabhowto': 'Si të arrish',
      'tabviability': 'Përshkueshmëria',
      'tabwalkable': 'Aksesueshmëria',
      'viability': {
        'info': 'Informacione të tjera',
        'title': 'Praktikueshmëria e rrugës'
      }
    },
    'store': {
      'button1': '1 Monedhë e Vetme',
      'button100': 'Pako 100 monedha',
      'button20': ' Pako 20 Monedha',
      'button50': 'Pako 50 monedha',
      'main': 'Monedhat Webmapp',
      'text': 'Mund të blesh një Monedhë të vetme, ose të zgjedhësh mes një ose më shumë pakove!',
      'text2': 'Monedhat shërbejnë për të shkarkuar gjurmë dhe përmbajtje jashtë linje, dhe për të aksesuar shumë përfitime!',
      'title': 'Dyqani'
    },
    'trackdetail': {
      'avgspeed': 'Shpejtësia mesatare',
      'delete': 'Fshi regjistrimin',
      'details': 'Detajet',
      'distance': 'Km të përshkuara',
      'edit': 'Modifiko regjistrimin',
      'photos': 'Foto',
      'slope': 'Diferenca e lartësisë',
      'time': 'Koha',
      'title': 'Gjurmë e regjistruar',
      'topspeed': 'Shpejtësia maksimale'
    },
    'tracklist': {
      'noitem': 'Aktualisht nuk ka gjurmë të regjistruara',
      'title': 'Gjurmë të regjistruara'
    },
    'waypoint': {
      'here': 'Je këtu:',
      'modalsave': {
        'formdescription': 'Përshkrimi',
        'formdescriptionplaceholder': 'Nëse dëshiron mund të shtosh një përshkrim',
        'formoptional': 'Opsionale',
        'formphotos': 'Shto foto të Pikës së Rrugës',
        'formtitle': 'Titulli i pikës së rrugës',
        'formtitleerror': 'Titulli i pikës së rrugës është i detyrueshëm',
        'formtitleplaceholder': 'Fut një titull',
        'formtype': 'Lloji i Pikës së Rrugës',
        'formtypeerror': 'Lloji i pikës së rrugës është i detyrueshëm',
        'formtypeplaceholder': 'Zgjidh',
        'phototextshort': 'Foto',
        'save': 'Ruaj ',
        'title': 'Regjistro një pikë të rrugës'
      },
      'save': 'Ruaj pikën e rrugës',
      'title': 'Regjistro një pikë të rrugës'
    },
    'waypointdetail': {
      'delete': 'Fshi regjistrimin',
      'edit': 'Modifiko regjistrimin',
      'title': 'Pika e rrugës e regjistruar'
    },
    'waypointlist': {
      'noitem': 'Aktualisht nuk ka pika të rrugës të regjistruara',
      'title': 'Pika të rrugës të regjistruara'
    },
    'project': {
      'title': 'Projekti'
    },
    'credits': {
      'title': 'Kredite',
      'webmappContent1': 'Aplikacioni {{appName}} është zhvilluar dhe mirëmbajtur nga Webmapp.<br> Webmapp realizon shërbime kartografike në internet, aplikacione mobile, dhe kartografi të shtypur për Turizmin e Natyrës & Aventurës.<br>Për më shumë informacion vizitoni faqen tonë të internetit ',
      'webmappContent2': " ose na shkruani në adresën <a href=\"mailto:info@webmapp.it\">info@webmapp.it</a>",
      'map': 'Harta',
      'mapContent': '© Webmapp, shpërndarë me licencë CC BY-NC-SA',
      'cartographicData': 'Të dhënat kartografike',
      'cartographicDataContent': '© Kontribuesit e OpenStreetMap'
    },
    'disclaimer': {
      'title': 'Mohim',
      'content': "Ecja në natyrë dhe, më gjerë, aktivitetet në natyrë, janë aktivitete potencialisht të rrezikshme: para se të niseni për një ekskursion sigurohuni që keni njohuritë dhe aftësitë për ta bërë këtë. Nëse nuk jeni të sigurt, drejtohuni tek ekspertët lokalë që mund t'ju ndihmojnë, sugjerojnë dhe mbështesin në planifikimin dhe zhvillimin e aktiviteteve tuaja. Të dhënat e paraqitura në këtë APLIKACION nuk mund të garantojnë plotësisht përshkueshmërinë pa rreziqe të rrugës: mund të kenë ndodhur ndryshime, edhe të rëndësishme, që nga verifikimi i fundit i rrugës. Prandaj është thelbësore që ata që synojnë të zhvillojnë aktivitete të vlerësojnë me kujdes mundësinë e vazhdimit bazuar në sugjerimet dhe këshillat e përmbajtura në këtë APLIKACION, bazuar në përvojën e tyre, kushtet meteorologjike (edhe të ditëve të mëparshme) dhe një vlerësim të bërë në terren në fillim të zhvillimit të aktivitetit. Shoqëria Webmapp S.r.l. nuk ofron garanci për sigurinë e vendeve të përshkruara, dhe nuk merr asnjë përgjegjësi për dëmet e mundshme të shkaktuara nga zhvillimi i aktiviteteve të përshkruara."
    }
  },
  'Layers': 'Layers',
  'Sentieri': 'Shtigjet',
  'Non ci sono cammini preferiti, clicca sull\'icona cuore di un cammino per aggiungerlo a questa lista':
    'Nuk ka shtigje të preferuara, kliko mbi ikonën e zemrës së një shtegu për ta shtuar në këtë listë',
  'services': {
    'geolocation': {
      'notification': {
        'text': {
          'newTrackRecord': 'Prek njoftimin për të hapur aplikacionin'
        },
        'title': {
          'newTrackRecord': 'Regjistrimi në proces'
        }
      }
    },
    'share': {
      'dialogTitle': 'Ndaj me miqtë e tu',
      'text': 'Ja një rrugë interesante nga webmapp',
      'title': 'E ke parë këtë rrugë?',
      'url': 'www.webmapp.it'
    }
  },
  'tabs': {
    'favourites': 'të preferuarat',
    'home': 'kryefaqja',
    'map': 'harta',
    'profile': 'profili'
  },
  'no-tracks': 'Nuk ke shkarkuar ende asnjë gjurmë',
  'hiking': 'Ecje në natyrë',
  'skitouring': 'Skitour',
  'walking': 'Shëtitje',
  'running': 'Vrapim',
  'asphalt': 'Asfalt',
  'bitumenduro': 'Bitumenduro',
  'onoff': 'On/Off',
  'real-dirt': 'Dhe i vërtetë',
  'bar': 'Bar',
  'cycling': 'Çiklizëm',
  'poi_type': 'pika interesi',
  'where': 'vende',
  'I tuoi dati': 'Të dhënat e tua',
  'Scarica il tracciato GPX': 'Shkarko gjurmën GPX',
  'Scarica il tracciato KML': 'Shkarko gjurmën KML',
  'Scarica il tracciato GEOJSON': 'Shkarko gjurmën GEOJSON',
  'Elimina account': 'Fshi llogarinë',
  "Digita 'elimina account'": "Shkruaj 'fshi llogarinë'",
  "La conferma non corrisponde. È necessario scrivere 'elimina account' per procedere.": "Konfirmimi nuk përputhet. Është e nevojshme të shkruash 'fshi llogarinë' për të vazhduar.",
  'Azione irreversibile': 'Veprim i pakthyeshëm',
  'Attenzione': 'Kujdes',
  'Annulla': 'Anulo',
  'Conferma': 'Konfirmo',
  'Link utili': 'Lidhje të dobishme',
  "Per registrare tracce e poi correttamente, abilita l'autorizzazione alla posizione nelle impostazioni": "Për të regjistruar gjurmë dhe për t'i shfaqur ato saktë, aktivizo lejen e vendndodhjes në cilësime",
  'Apri impostazioni App': 'Hap cilësimet e aplikacionit',
  'Ti trovi qui': 'Je këtu',
  'Salva Waypoint': 'Ruaj pikën e rrugës',
  'Salva Traccia': 'Ruaj gjurmën',
  'Impossibile caricare i cammini preferiti, riprova':
    'Nuk u arrit të ngarkoheshin shtigjet e preferuara, provo përsëri',
  'privacy': {
    'agree': {
      'title': 'Përpunimi i të dhënave',
      'message': 'Pranoj që të dhënat e mia të publikohen',
      'read_privacy': 'Lexo informacionin për përpunimin e të dhënave',
      'accept': 'Prano',
      'reject': 'Refuzo',
      'confirm': {
        'title': 'Konfirmo ndryshimin',
        'accept_message': 'A jeni të sigurt që dëshironi të pranoni përpunimin e të dhënave?',
        'reject_message': 'A jeni të sigurt që dëshironi të refuzoni përpunimin e të dhënave?',
        'yes': 'Po, konfirmo',
        'no': 'Anulo'
      },
      'final_confirm': {
        'title': 'Ndryshimi u përfundua',
        'accept_message': 'Pëlqimi për përpunimin e të dhënave u pranua me sukses.',
        'reject_message': 'Pëlqimi për përpunimin e të dhënave u refuzua me sukses.',
        'ok': 'OK'
      }
    }
  }
};
